import React, { useRef, useState } from 'react'
import ReactDOM from 'react-dom'
import _ from 'underscore'

import LocationClass from './../../../../../../../js/classes/Location.js'

import SearchItem from './SearchItem.jsx'

const Search = ({ handleSetCurrentTown }) => {
    const searchInput = useRef(null),
    [phrase, setPhrase] = useState(''),
    [searchItems, setSearchItems] = useState([]),
    handleSearch = _.debounce(() => {
        const _phrase = searchInput.current.value

        setPhrase(_phrase)
        
        LocationClass.search((err, res) => {
            if (err) {

            } else {
                setSearchItems(res)
            }
        }, _phrase)
    }, 250)

    return <div className="happy-select-location__search">
        <div className="happy-select-location__search-title">
            Или укажите в поле
        </div>
        
        <div className="happy-select-location__search-input">
            <input type="text" onKeyUp={ handleSearch } ref={ searchInput } placeholder="Введите название города" />
        </div>

        <div className="happy-select-location__autocomplite">
            { searchItems.map((location) => {
                return <SearchItem
                    key={ `search-item-${ location.ID }` }
                    location={ location }
                    phrase={ phrase }
                    handleSetCurrentTown={ handleSetCurrentTown }
                />
            }) }
        </div>
    </div>
}

export default Search